<template>
  <VHistory business-model="factoring" :route-overview="BARRING_FACTORING_HISTORY" :route-details="BARRING_FACTORING_HISTORY_STATUS">
    <template #header>
      <VButton label="barring.button_backTo3rdPartyStatusPage" class="btn-brand offset-bottom-2" :to="{ name: BARRING_FACTORING_STATUS }" />

      <p v-html="$t('barring.history_details_text')"></p>
    </template>

    <template
      #details="{ validFrom, validTo, items, isProfileTypeCategories, isFactoringBarred, itemsWithoutExceptions, itemsWithExceptions, isVoiceFactoringBarred, factoringItems, voiceFactoringItems, hasVoiceFactoringExceptions, voiceFactoringExceptions }"
    >
      <h4
        class="h3"
        v-html="
          $t('barring.history_details_headline', {
            validFrom,
            validTo,
            profile: $t('barring.statusType_' + (isProfileTypeCategories ? 'category' : 'factoring')),
          })
        "
      />

      <section v-if="isProfileTypeCategories" role="list" class="offset-top-2 offset-bottom-3">
        <VStatus role="listitem" type="category" :is-barred="isFactoringBarred" :items="itemsWithoutExceptions" />
        <VStatus v-if="itemsWithExceptions.length" role="listitem" type="category-exceptions" :is-barred="isFactoringBarred" :items="itemsWithExceptions" />
      </section>
      <section v-else role="list" class="offset-top-2 offset-bottom-3">
        <VStatus role="listitem" type="factoring" :is-barred="isFactoringBarred" :items="factoringItems" />
        <VStatus role="listitem" type="voiceFactoring" :is-barred="isVoiceFactoringBarred" :items="voiceFactoringItems" />
        <VStatus v-if="hasVoiceFactoringExceptions" role="listitem" type="exceptions" :is-barred="isVoiceFactoringBarred" :items="voiceFactoringExceptions" />
      </section>

      <VButton class="btn btn-default btn-brand" label="barring.history_show_profile_button_label" @click="onShow(items)" />
    </template>
  </VHistory>
</template>

<script>
import VButton from '@/components/Button';
import VHistory from '@/components/Barring/History';
import VStatus from '@/components/Barring/Status';
import { BARRING_FACTORING_HISTORY_SHOW, BARRING_FACTORING_STATUS, BARRING_FACTORING_HISTORY, BARRING_FACTORING_HISTORY_STATUS } from '@route-types';

export default {
  name: 'BarringFactoringHistory',

  components: {
    VButton,
    VHistory,
    VStatus,
  },

  data() {
    return {
      BARRING_FACTORING_STATUS,
      BARRING_FACTORING_HISTORY,
      BARRING_FACTORING_HISTORY_STATUS,
    };
  },

  methods: {
    onShow(items) {
      this.$store.dispatch('barring/setEditItems', items);
      this.$router.push({ name: BARRING_FACTORING_HISTORY_SHOW, params: { edit: true, readOnly: true } });
    },
  },
};
</script>
